import moment from 'moment';
import Daily from '../daily';
import Weekly from '../weekly';
import noNetTip from "../components/NoNetTip";
import { getOpenSleepDayReport, getOpenSleepWeekReport, getOpenSleepMonthReport } from "@/utils/api";
import { Loading } from 'vant';
export default {
  name: 'sleep',
  components: {
    VanLoading: Loading,
    Daily: Daily,
    Weekly: Weekly,
    noNetTip: noNetTip
  },
  data: function data() {
    return {
      wwid: "",
      vpaToken: "",
      isloading: true,
      mode: "day",
      year: "",
      month: "",
      day: "",
      week: "",
      dayRes: [],
      weekRes: {},
      monthRes: {},
      isVip: true,
      noNet: false
    };
  },
  watch: {
    '$route': {
      handler: function handler(route) {
        this.getDateByRoute(route);
      },
      immediate: true
    }
  },
  created: function created() {
    var _this = this;

    this.getDateByRoute(this.$route);
    this.queryIsVip(); // 设置年龄之后刷新周报、月报数据

    window.reQuery = function () {
      _this.getDateByRoute(_this.$route);
    }; // 开通vip之后重新请求是否vip


    window.reQueryVip = function () {
      _this.queryIsVip();
    };
  },
  methods: {
    // 通过路由获取选中模式和日期
    getDateByRoute: function getDateByRoute(route) {
      var _ref = route.query || {},
          mode = _ref.mode;

      var _ref2 = route.params || {},
          year = _ref2.year,
          month = _ref2.month,
          day = _ref2.day,
          wwid = _ref2.wwid,
          vpaToken = _ref2.vpaToken;

      this.wwid = wwid;
      this.vpaToken = vpaToken;

      if (mode) {
        this.mode = mode;
      }

      this.year = year || moment().year();
      this.month = month || moment().month() + 1;
      this.day = day || moment().date();
      this.noNet = false;

      switch (this.mode) {
        case 'day':
          this.queryDayData(this.year, this.month, this.day);
          break;

        case 'week':
          var _this$getWeek = this.getWeek(+this.year, +this.month, +this.day),
              y = _this$getWeek.year,
              m = _this$getWeek.month,
              week = _this$getWeek.week;

          this.year = y;
          this.month = m;
          this.week = week;
          this.queryWeekData(this.year, this.month, this.week);
          break;

        case 'month':
          this.queryMonthData(this.year, this.month);
          break;

        default:
          break;
      }
    },
    // 第一周星期一为几号
    getFirstMondayOfMonth: function getFirstMondayOfMonth(year, month) {
      var xq = new Date(year, month - 1, 1).getDay(); // 1号周几

      if (xq === 1) return 1;
      xq = xq ? xq : 7;
      return 7 - xq + 2;
    },
    // 获取这天为第几周（周定义为当前月第一个星期一为第一周）
    getWeek: function getWeek(year, month, day) {
      var result = {
        year: year,
        month: month,
        week: 1
      };
      var firstMondayOfMonth = this.getFirstMondayOfMonth(year, month);

      if (day < firstMondayOfMonth) {
        // 为上个月最后一周
        var d = new Date(year, month - 1, 0);
        return this.getWeek(d.getFullYear(), d.getMonth() + 1, d.getDate());
      } else {
        result.week = Math.floor((day - firstMondayOfMonth) / 7) + 1;
      }

      return result;
    },
    // 请求日报数据
    queryDayData: function queryDayData(year, month, day) {
      var _this2 = this;

      this.isloading = true;
      var wwid = this.wwid,
          vpaToken = this.vpaToken;
      getOpenSleepDayReport({
        year: year,
        month: month,
        day: day,
        wwid: wwid,
        vpaToken: vpaToken
      }).then(function (res) {
        // console.log('getOpenSleepDayReport', res);
        _this2.dayRes = res;
        _this2.isloading = false;

        _this2.$nextTick(function () {
          _this2.$refs.daily && _this2.$refs.daily.changeRes(res);
        });
      }).catch(function (err) {
        _this2.isloading = false;

        if (err.code === "ECONNABORTED") {
          _this2.noNet = true;
        }
      });
    },
    // 请求周报数据
    queryWeekData: function queryWeekData(year, month, week) {
      var _this3 = this;

      this.isloading = true;
      var wwid = this.wwid,
          vpaToken = this.vpaToken;

      var _ref3 = this.$route.params || {},
          weekYear = _ref3.year,
          weekMonth = _ref3.month,
          weekDay = _ref3.day;

      getOpenSleepWeekReport({
        year: year,
        month: month,
        week: week,
        wwid: wwid,
        vpaToken: vpaToken,
        weekYear: weekYear,
        weekMonth: weekMonth,
        weekDay: weekDay
      }).then(function (res) {
        // console.log('getOpenSleepWeekReport', res)
        _this3.weekRes = res;
        _this3.isloading = false;

        _this3.$nextTick(function () {
          _this3.$refs.weekly && _this3.$refs.weekly.changeRes(res);
        });
      }).catch(function (err) {
        _this3.isloading = false;

        if (err.code === "ECONNABORTED") {
          _this3.noNet = true;
        }
      });
    },
    // 请求月报数据
    queryMonthData: function queryMonthData(year, month) {
      var _this4 = this;

      this.isloading = true;
      var wwid = this.wwid,
          vpaToken = this.vpaToken;
      getOpenSleepMonthReport({
        year: year,
        month: month,
        wwid: wwid,
        vpaToken: vpaToken
      }).then(function (res) {
        // console.log('getOpenSleepMonthReport', res)
        _this4.monthRes = res;
        _this4.isloading = false;

        _this4.$nextTick(function () {
          _this4.$refs.monthly && _this4.$refs.monthly.changeRes(res);
        });
      }).catch(function (err) {
        _this4.isloading = false;

        if (err.code === "ECONNABORTED") {
          _this4.noNet = true;
        }
      });
    },
    // 请求是否为会员
    queryIsVip: function queryIsVip() {
      this.isVip = true; // getVipFlag().then(res => {
      //   console.log('getVipFlag', res)
      //   this.isVip = res.vipFlag === 1;
      // })
    }
  }
};